
import { RevenueOrg } from '../RevenueOrg';

export class RevenueOrgPa extends RevenueOrg {

  constructor(props) {
    super(props, {pageForOrgType: 'PA'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/pas/RevenueOrgPa.js